
export function isgValidatorTextRequired(value: any, callback: (value: boolean) => void) {
  callback(!!value?.toString().trim());
}
